/**
 * Muted, professional categorical palette for the carbon dashboard — a calmer
 * alternative to the kit's saturated DEFAULT_COLORS, matching the restrained
 * look NetZero uses. Shared by the trend lines, chips, and top-KPI bars so a
 * given KPI keeps one colour everywhere.
 */
export const SCOPE_PALETTE = [
  "#3f6db0",
  "#4f9d69",
  "#c98a34",
  "#b0574c",
  "#7a6ca6",
  "#3f9a97",
  "#a8708f",
  "#6b7785",
  "#9a7b3f",
  "#5b8ca5",
];

/** Stable colour for the i-th item (KPI or category) in a scope. */
export const scopeColorAt = (i) => SCOPE_PALETTE[i % SCOPE_PALETTE.length];
